// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mp-2";
export var interactiveWrapper = "_mp-0";
export var shippingHoverPreview = "_mp-4";
export var summaryBadgeTrigger = "_mp-1";
export var widgetHoverPreviewList = "_mp-3";
export var widgetPreviewScale = "_mp-5";